import React from 'react';
import { connect } from 'formik';
import AddItemsList from 'components/common/AddItemsList';

// eslint-disable-next-line react/jsx-props-no-spreading
const FormItems = ({ formik: { values, dirty }, ...props }) => <AddItemsList data={values} dirty={dirty} {...props} />;

export default connect(FormItems);
